// Thanh có số (UI_SPEC §10.3): khuôn duy nhất cho tiến độ x/y. Số nằm TRONG thanh; màu đổi theo
// mốc (< 50% lam xám · ≥ 50% teal · đầy kim). Số dài rút gọn Vạn / Ức khi max ≥ 10⁶.
import type { JSX } from 'preact';
import { formatCompact, formatFull } from '@i18n/format';

export function NumBar(props: {
  value: number;
  max: number;
  ariaLabel: string;
  id?: string;
  /** Rung nhẹ một nhịp khi khóa này đổi (juice đột phá tiểu cảnh). */
  shakeKey?: number;
  class?: string;
}): JSX.Element {
  const { value, max } = props;
  const p = max > 0 ? Math.max(0, Math.min(1, value / max)) : 0;
  const mark = p >= 1 ? 'm-full' : p >= 0.5 ? 'm-near' : 'm-start';
  const fmt = (n: number): string => (max >= 1e6 ? formatCompact(n) : formatFull(Math.floor(n)));
  // Tính toán giữ float (BALANCE §0); vẽ thì trần làm tròn, đầy thanh thì hai số bằng nhau.
  const shownMax = Math.round(max);
  const shownValue = p >= 1 ? shownMax : Math.min(value, shownMax);
  return (
    <div
      class={`ht-numbar ${mark}${props.class ? ` ${props.class}` : ''}`}
      data-id={props.id}
      role="meter"
      aria-valuemin={0}
      aria-valuemax={max}
      aria-valuenow={Math.floor(value)}
      aria-label={props.ariaLabel}
      style={{ '--p': String(p) }}
      key={props.shakeKey === undefined ? undefined : `shake-${props.shakeKey}`}
    >
      <i />
      <b>
        {fmt(shownValue)} / {fmt(shownMax)}
      </b>
    </div>
  );
}
